import { BaseTag } from "mixs/base/base_mixin";

class BlackOver extends BaseTag {
  init(){
    super.init();
    this.watch();
  }
  onClick(){
    this.dispatch({show: false});
    return false;
  }
}

riot.mixin("shared.black-over", BlackOver as riot.TagMixin);
